export function makeTaskActionType(taskActionType: string): string {
  return `uf/task/${taskActionType}`;
}
